import useLogisticOperatorAutocomplete from './useLogisticOperatorAutocomplete';
import useLogisticOperatorsSearchBarHandlers from './useLogisticOperatorsSearchBarHandlers';
import useLogisticOperatorsSearchBarLocalState from './useLogisticOperatorsSearchBarLocalState';
import useLogisticOperatorsSearchBarSelectedOptions from './useLogisticOperatorsSearchBarSelectedOptions';
import type { LogisticOperatorsFilter } from '../models';

interface UseLogisticOperatorsSearchBarParams {
  initialFilter: LogisticOperatorsFilter;
  filter: LogisticOperatorsFilter;
  search: (next: LogisticOperatorsFilter) => void;
}

const useLogisticOperatorsSearchBar = ({
  initialFilter,
  filter,
  search,
}: UseLogisticOperatorsSearchBarParams) => {
  const {
    localFilter,
    setLocalFilter,
    nameInput,
    businessInput,
    setNameInput,
    setBusinessInput,
    setNameInputState,
    setBusinessInputState,
    nameId,
    businessId,
    resetFilters,
    isNameFieldDisabled,
    isBusinessFieldDisabled,
  } = useLogisticOperatorsSearchBarLocalState({
    filter,
    search,
    initialFilter,
  });

  const { selectedNameOption, selectedBusinessOption } =
    useLogisticOperatorsSearchBarSelectedOptions({ nameId, businessId });

  const {
    logisticOperatorOptions: nameSuggestionOptions,
    isLogisticOperatorsLoading: isNameLoading,
  } = useLogisticOperatorAutocomplete({
    search: nameInput,
    searchField: 'name',
  });

  const {
    logisticOperatorOptions: businessSuggestionOptions,
    isLogisticOperatorsLoading: isBusinessLoading,
  } = useLogisticOperatorAutocomplete({
    search: businessInput,
    searchField: 'businessName',
  });

  const { handleSearch, handleNameOperatorSelect, handleBusinessOperatorSelect } =
    useLogisticOperatorsSearchBarHandlers({
      localFilter,
      nameInput,
      businessInput,
      search,
      setLocalFilter,
      setNameInputState,
      setBusinessInputState,
    });

  return {
    selectedNameOption,
    selectedBusinessOption,
    nameInput,
    setNameInput,
    businessInput,
    setBusinessInput,
    nameSuggestionOptions,
    businessSuggestionOptions,
    isNameLoading,
    isBusinessLoading,
    handleNameOperatorSelect,
    handleBusinessOperatorSelect,
    resetFilters,
    handleSearch,
    isNameFieldDisabled,
    isBusinessFieldDisabled,
  };
};

export default useLogisticOperatorsSearchBar;
